import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from '../shared/Button';
import { ArrowLeftIcon } from 'lucide-react';
export const BookingPage = () => {
  useEffect(() => {
    // Load the HubSpot Meetings embed script
    const script = document.createElement('script');
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-b from-[#231232] to-[#1a0d24] flex flex-col" data-id="element-24">
      <Helmet data-id="element-25">
        <title data-id="element-26">Schedule Your Consultation | ApplyPass Platinum</title>
        <meta name="description" content="Schedule a consultation with our career transformation experts" data-id="element-27" />
      </Helmet>
      {/* Header */}
      <header className="w-full py-6 px-4 sm:px-6 lg:px-8 border-b border-[#6805DA]/20" data-id="element-28">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-29">
          <Button variant="ghost" href="/" q className="text-white/80 hover:text-white flex items-center gap-2" data-id="element-30">
            <ArrowLeftIcon size={18} data-id="element-31" />
            <span data-id="element-32">Back to Home</span>
          </Button>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1 py-12 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-33">
        <div className="max-w-4xl w-full mx-auto text-center mb-10" data-id="element-34">
          <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-6 text-white" data-id="element-35">
            Schedule Your Consultation
          </h1>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-36"></div>
          <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-37">
            Select a time that works for you to speak with our Head of Product and Operations, Beatrice, and explore how we can help you land your
            dream role.
          </p>
        </div>
        {/* HubSpot Meetings Embed */}
        <div className="w-full max-w-4xl bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-white/10" data-id="element-38">
          <div className="meetings-iframe-container" data-src="https://meetings.hubspot.com/applypass-beatrice/platinum?embed=true" data-id="element-39"></div>
          <div className="mt-8 text-center" data-id="element-40">
            <p className="text-white/60 text-sm" data-id="element-41">
              Having trouble with scheduling? Contact us at{' '}
              <a href="mailto:support@applypass.com" className="text-[#FFC501] hover:underline" data-id="element-42">
                support@applypass.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>;
};